import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { ASSETS } from "../../lib/site";

function formatError(detail) {
  if (!detail) return "Ocurrió un error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-glg-black px-5">
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-96 w-96 -translate-x-1/2 rounded-full bg-glg-blue/15 blur-[130px]" />
      <div className="relative w-full max-w-md">
        <div className="mb-8 flex flex-col items-center">
          <div className="rounded-2xl bg-white/[0.04] p-4">
            <img src={ASSETS.logo} alt="GLG Technology" className="h-12 w-auto" />
          </div>
          <h1 className="mt-6 font-heading text-2xl font-bold text-white">Panel administrativo</h1>
          <p className="mt-1 text-sm text-white/50">Ingresa para gestionar el contenido</p>
        </div>

        <form onSubmit={submit} data-testid="login-form" className="rounded-3xl border border-white/10 bg-glg-surface/70 p-8 backdrop-blur-sm">
          {error && (
            <div data-testid="login-error" className="mb-5 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300">
              {error}
            </div>
          )}
          <label className="mb-2 block text-xs font-medium uppercase tracking-wider text-white/50">Correo</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
            placeholder="correo@glghn.com"
            className="mb-5 w-full rounded-xl border border-white/10 bg-glg-black/60 px-4 py-3 text-sm text-white outline-none focus:border-glg-blue"
            required
          />
          <label className="mb-2 block text-xs font-medium uppercase tracking-wider text-white/50">Contraseña</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
            placeholder="••••••••"
            className="mb-6 w-full rounded-xl border border-white/10 bg-glg-black/60 px-4 py-3 text-sm text-white outline-none focus:border-glg-blue"
            required
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-glg-blue px-6 py-3.5 text-sm font-semibold text-white transition-transform hover:scale-[1.02] disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
            Ingresar
          </button>
        </form>
        <p className="mt-6 text-center text-xs text-white/30">GLG Technology · Panel privado</p>
      </div>
    </div>
  );
}
